import * as actionTypes from './actionTypes';
import axios from "axios";

export const changeViewType = (type) => {
    return {
        type: actionTypes.SEARCH_PAGE_VIEW_TYPE,
        viewType: type
    }
};

export const changeVehicleType = (type) => {
    localStorage.setItem('vehicleType', type)
    return {
        type: actionTypes.SEARCH_VEHICLE_TYPE,
        vehicleType: type
    }
};

// ######################### Fetching Vehicle items :

export const initGetVehicleItems = () => {
    return {
        type: actionTypes.INIT_GET_VEHICLE_ITEMS,
        itemsLoading: true,
        commingSoon : false
    }
}

export const successGetVehicleItems = (data, url) => {
    return {
        type: actionTypes.SUCCESS_GET_VEHICLE_ITEMS,
        vehicleItems: data,
        itemsLoading: false,
        currentURL: url,
        commingSoon : false
    }

}

export const failGetVeghicleItems = (error) => {
    return {
        type: actionTypes.FAIL_GET_VEHICLE_ITEMS,
        error: error,
        itemsLoading: false,
        commingSoon : false
    }
}

export const showCommingSoon = () => {
    return {
        type: actionTypes.COMMING_SOON,
        commingSoon : true
    }
};

export const getVehicleItems = (type, pageNum = 1, brand, urlink) => {
    let url
    if (urlink && !brand) {
        url = urlink
    }
    else if (brand && !urlink) {
        url = `${type}/lists?search=${brand}&per_page=9&page=${pageNum}`

    }
    else {
        url = `${type}/lists?per_page=9&page=${pageNum}`
    }
    return dispatch => {
        if (type === 'cars' || type === 'motors' || type === 'commercials' || type === 'all') {
            dispatch(initGetVehicleItems())
            axios.get(url)
                .then(response => {
                    dispatch(successGetVehicleItems(response.data, url))
                })
                .catch(error => {
                    dispatch(failGetVeghicleItems())
                })
        }
        else{
            dispatch(showCommingSoon())
        }

    }

}
